import "bootstrap-icons/font/bootstrap-icons.css";

import { Col, Row } from "react-bootstrap";
import parse from "html-react-parser";
import { Link } from "react-router-dom";

import EnquiryForm from "components/forms/EnquiryForm";
import { JumbotronBiz } from "sections";
import { eligibility } from "constants/eligibility";
import { LinkButton } from "components/buttons";
import ScrollAnimatedProgressBar from "components/progressbar/ScrollAnimatedProgressBar";

import ca_biz from "assets/images/ca_biz.svg";
import currency from "assets/images/currency_icons.svg";
import outline_check from "assets/images/outline_check.svg";
import DepositImage from "assets/images/hero-images/Banner_Deposit.png";
import BG from "assets/images/hero-images/BG.png";

function CurrentAccountBiz() {
  return (
    <div>
      <section className="section jumbotron">
        <JumbotronBiz
          badgeText="Deposits"
          title={`Current
              <span className="jumbotron-subtitle-2">
                Account-<i>i</i>
              </span>`}
          buttonText="Reach out to us!"
          footNotes="Protected by PIDM up to RM250,000 for each depositor"
          backgroundImage={DepositImage}
          uniqueBg={BG}
        />
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>About</h3>
          </div>
          <div className="col-xl-8">
            <p>
              Our Qard Current Account-<em>i</em> provides a flexible
              banking solution tailored to your daily financial needs. Available
              in Malaysian Ringgit and 12 other major currencies, this account
              offers easy access to your money through online banking,
              ensuring a straightforward and transparent experience.
            </p>
            <img
              style={{ width: "100%" }}
              src="https://www.alrajhibank.com.my/assets/images/currency/currency_logo.svg"
              className="d-inline-block align-top"
              alt=""
            />
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4">
            <h3>Features</h3>
          </div>
          <div className="col-xl-8">
            <div className="row">
              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Initial deposit</div>
                <div className="column-subheader">
                  RM500 or USD5,000 or its equivalent
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Cheque book</div>
                <div className="column-subheader">
                  alrajhi bank Malaysia cheque book available upon request
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Currency</div>
                <div className="column-subheader">
                  Available in MYR & selected foreign currencies
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Shariah standards</div>
                <div className="column-subheader">
                  In compliance with alrajhi bank Malaysia's Shariah standard
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4">
            <h3>Benefits</h3>
          </div>
          <div className="col-xl-8">
            <div className="row">
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">
                  Internet Banking facilities
                </div>
                <div className="column-subheader-2">
                  To easily manage fund transfers and balance enquiries
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">e-Statement</div>
                <div className="column-subheader-2">
                  Monthly statement will be provided to the customers
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Alerts</div>
                <div className="column-subheader-2">
                  SMS will be sent to customers for any notifications{" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Shariah Contract</div>
                <div className="column-subheader-2">Qard (loan) </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <Row>
          <Col md={4}>
            <h3>Eligibility</h3>
          </Col>
          <Col md={8}>
            <ScrollAnimatedProgressBar data={eligibility}>
              {eligibility.points.eligibilitycurrentbiz.description.map(
                (benefit, index) => (
                  <div className="animated-list z-1">
                    <div className="check">
                      <img src={outline_check} width="22" alt="outline_check" />
                    </div>
                    <div
                      data-aos="zoom-in-down"
                      data-aos-delay={`${index + 1}00`}
                    >
                      {parse(benefit)}
                    </div>
                  </div>
                )
              )}
            </ScrollAnimatedProgressBar>
          </Col>
        </Row>
      </section>

      <section className="section about container">
        <div
          className="row"
          style={{ justifyContent: "flex-start", alignContent: "flex-start" }}
        >
          <div className="col-xl-4"></div>
          <div className="col-xl-8">
            <div className="link-button-row">
              <LinkButton
                text="Fees and Charges"
                onClick={() =>
                  window.open(
                    "https://www.alrajhibank.com.my/assets/pdf/deposits/fees_and_charges.pdf"
                  )
                }
              />
              <Link to="/tnc" className="w-full">
                <LinkButton text="Terms and Conditions" />
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Reach out to us! </h3>
            <p>
              Share your details, and we'll get back to you as soon as possible.
            </p>
          </div>
          <div className="col-xl-8">
            <EnquiryForm />
          </div>
        </div>
      </section>
    </div>
  );
}

export default CurrentAccountBiz;
